// extracted by mini-css-extract-plugin
module.exports = {"image-wrapper":"HaveNotPin_image-wrapper__XsrNC","title":"HaveNotPin_title__1kosi","description-text":"HaveNotPin_description-text__3CBKc","bold":"HaveNotPin_bold__1vUll"};